export default {
    '1a-diagram2': {
        'diagram-task': 'Arrange the points to fit the pyramid structure, then press Complete to see your answer',
        'element_2_3': 'Shift competitive stores to match',
        'element_2_2': 'Survey only A-type stores',
        'element_2_1': 'Make sure the data reflect the marketplace',
        'element_2_4': 'Change the self-serve ratio'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/1/1a/diagram2/i18n/en.js